module.exports = __webpack_public_path__ + "static/media/anchor.836e0908.svg";